<button class="btn text-danger fw-bold d-flex align-items-center" (click)="onSubmit()" *ngIf="hasPermission()">
  <i class="bi bi-trash p-2"></i></button>
